import React, { useEffect, useMemo, useState } from "react";

const pageStyle = {
  minHeight: "100vh",
  background: "#0A0A0A",
  color: "#FFFFFF",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 24,
  fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, sans-serif",
};

const cardStyle = {
  width: "100%",
  maxWidth: 460,
  background: "#141414",
  border: "1px solid rgba(255,255,255,0.08)",
  borderRadius: 16,
  padding: 32,
  textAlign: "center",
};

const buttonStyle = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  minHeight: 46,
  padding: "0 22px",
  borderRadius: 999,
  background: "linear-gradient(135deg, #0C69C8 0%, #0A3D7A 100%)",
  color: "#FFFFFF",
  textDecoration: "none",
  fontWeight: 800,
  border: "none",
  cursor: "pointer",
};

export default function MobileAuthCallback() {
  const [status, setStatus] = useState("Opening Snows ProAm...");

  const appUrl = useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const error = params.get("error");
    const errorDescription = params.get("error_description");

    if (error || errorDescription) {
      const query = new URLSearchParams();
      if (error) query.set("error", error);
      if (errorDescription) query.set("error_description", errorDescription);
      return `snowsproam://auth/callback?${query.toString()}`;
    }

    if (!code) return null;
    return `snowsproam://auth/callback?code=${encodeURIComponent(code)}`;
  }, []);

  useEffect(() => {
    if (!appUrl) {
      setStatus("We could not finish Google sign-in because the callback code was missing.");
      return;
    }

    const timer = setTimeout(() => {
      window.location.href = appUrl;
    }, 250);

    return () => clearTimeout(timer);
  }, [appUrl]);

  return (
    <main style={pageStyle}>
      <section style={cardStyle} aria-live="polite">
        <div style={{ height: 4, margin: "-32px -32px 28px", background: "linear-gradient(90deg, #0C69C8, #0A1D44)" }} />
        <h1 style={{ margin: "0 0 12px", fontSize: 26, lineHeight: 1.2 }}>Return to the app</h1>
        <p style={{ margin: "0 auto 24px", maxWidth: 360, color: "rgba(255,255,255,0.78)", lineHeight: 1.6 }}>
          {status}
        </p>
        {appUrl && (
          <button type="button" onClick={() => { window.location.href = appUrl; }} style={buttonStyle}>
            Open Snows ProAm
          </button>
        )}
        <p style={{ margin: "24px auto 0", maxWidth: 360, color: "rgba(255,255,255,0.72)", fontSize: 14, lineHeight: 1.6 }}>
          If the app does not open, return to Snows ProAm and try again. Need help?{" "}
          <a href="mailto:support@snowsproam.com" style={{ color: "#0C69C8", textDecoration: "none", fontWeight: 800 }}>
            support@snowsproam.com
          </a>
        </p>
      </section>
    </main>
  );
}
